export const HELPER_RESET = 'helper/reset';
export const helperReset = () => ({
  type: HELPER_RESET
});

export const HELPER_TRANSACTION_STATUS_ONLOAD = 'helper/transaction_status_on_load';
export const transactionStatusOnLoad = () => ({
  type: HELPER_TRANSACTION_STATUS_ONLOAD
});

export const HELPER_TRANSACTION_STATUS_SUCCESS = 'helper/transaction_status_success';
export const transactionStatusSuccess = data => ({
  type: HELPER_TRANSACTION_STATUS_SUCCESS,
  payload: data
});

export const HELPER_COMMON1_ONLOAD = 'helper/common1_on_load';
export const common1OnLoad = () => ({
  type: HELPER_COMMON1_ONLOAD
});

export const HELPER_COMMON1_SUCCESS = 'helper/common1_success';
export const common1Success = data => ({
  type: HELPER_COMMON1_SUCCESS,
  payload: data
});

export const HELPER_COUNTRIES_ONLOAD = 'helper/countries_on_load';
export const countriesOnLoad = () => ({
  type: HELPER_COUNTRIES_ONLOAD
});

export const HELPER_COUNTRIES_SUCCESS = 'helper/countries_success';
export const countriesSuccess = data => ({
  type: HELPER_COUNTRIES_SUCCESS,
  payload: data
});

export const HELPER_FLOW_INFO_ONLOAD = 'helper/flow_info_on_load';
export const flowInfoOnLoad = () => ({
  type: HELPER_FLOW_INFO_ONLOAD
});

export const HELPER_FLOW_INFO_SUCCESS = 'helper/flow_info_success';
export const flowInfoSuccess = data => ({
  type: HELPER_FLOW_INFO_SUCCESS,
  payload: data
});

export const HELPER_PAYMENT_MODES_ONLOAD = 'helper/payment_modes_on_load';
export const paymentModesOnLoad = () => ({
  type: HELPER_PAYMENT_MODES_ONLOAD
});

export const HELPER_PAYMENT_MODES_SUCCESS = 'helper/payment_modes_success';
export const paymentModesSuccess = data => ({
  type: HELPER_PAYMENT_MODES_SUCCESS,
  payload: data
});

